import React, { Component } from 'react'
import FlagSmall from '../FlagSmall'
import './_styles.scss'
import Translator from '../../../../../requests/apa/Translator'
import Utils from '../../../../../utils/Utils'
import { matchSchedule, matchInProgress } from '../../../constants'
import Tag from '../Tag/Tag'
import { showModal, MODAL_MATCH_DETAIL } from '../../../../../actions/modal'
import store from '../../../../../store'
import { playmatch, getPhase2Config, sendMetricSelectContent, normalizeText, getMatchWinner, getIsFinishedMatch, getMatchName, getMatchScore } from '../../../utils'
import { Button } from '../../../../../packages/components'

class CardPartidoSquare extends Component {
  constructor (props) {
    super(props)
    this.isPhase2Enabled = getPhase2Config()
  }

  handleCardClick = () => {
    const { onClick, time, timezone, homeTeam, awayTeam, venue, matchId, status, date, path, liveScore } = this.props

    const mainMenuLabel = path && path.mainMenuLabel ? path.mainMenuLabel : null
    const parentTabLabel = path && path.parentTabLabel ? path.parentTabLabel : null
    const childTabLabel = path && path.childTabLabel ? path.childTabLabel : null

    // Usar marcador en vivo para consistencia entre UI y métricas
    const effectiveHomeTeam = (liveScore && homeTeam) ? { ...homeTeam, score: liveScore.homeScore } : homeTeam
    const effectiveAwayTeam = (liveScore && awayTeam) ? { ...awayTeam, score: liveScore.awayScore } : awayTeam

    const matchWinner = getMatchWinner(effectiveHomeTeam, effectiveAwayTeam)
    const isFinishedMatch = getIsFinishedMatch(status)
    const matchName = getMatchName(effectiveHomeTeam, effectiveAwayTeam)
    const matchScore = getMatchScore(effectiveHomeTeam, effectiveAwayTeam)
    const match = {
      statusCard: status ? normalizeText(status) : null,
      contentId: matchId ? matchId : null,
      contentName: matchName,
      contentLocation: venue ? normalizeText(venue) : null,
      contentStartDate: date ? normalizeText(date) : null,
      finalScore: isFinishedMatch ? matchScore : null, 
      matchWinner: isFinishedMatch ? matchWinner : null,
      matchTime: time
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps: {
        matchData: {
          time,
          timezone,
          homeTeam,
          awayTeam,
          venue,
          matchId,
          status,
          path
        },
        callback: (groupId, pinAlreadyValidated) => playmatch(groupId, pinAlreadyValidated)
      }
    }))
    if (typeof onClick === 'function') onClick()

    // Métricas
    sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel, match)
  }
  
  render () {
    const {
      time,
      timezone,
      homeTeam,
      awayTeam,
      venue,
      isFocused,
      status,
      scheduledAt,
      broadcast,
      matchProgress,
      liveScore
    } = this.props

    const home = homeTeam || {}
    const away = awayTeam || {}

    const displayHomeScore = liveScore && liveScore.homeScore !== undefined ? liveScore.homeScore : home.score
    const displayAwayScore = liveScore && liveScore.awayScore !== undefined ? liveScore.awayScore : away.score

    return (
      <Button 
        className={`card-partido-square${isFocused ? ' card-partido-square--focused' : ''} ${status === matchInProgress ? ' card-partido-square--in-progress' : ''} ${this.isPhase2Enabled ? 'focusable' : ''}`} 
        tabIndex={0} 
        onClick={this.isPhase2Enabled ? this.handleCardClick : () => {}}
      >
        {/* Time & timezone */}
        <p className='card-partido-square__time'>
          <Tag
            broadcast={broadcast}
            status={status}
            matchProgress={matchProgress}
            time={time}
            timezone={timezone}
            scheduledAt={scheduledAt}
          />
        </p>

        {/* Teams row */}
        <div className='card-partido-square__teams'>
          <FlagSmall
            flagUrl={home.flagUrl}
            countryName={home.name}
            iconSize='medium'
          />

          <span className='card-partido-square__vs'>
            {
              (liveScore || (status && status !== matchSchedule)) && displayHomeScore !== undefined && displayAwayScore !== undefined
                ? Utils.cutPlayerString(`${displayHomeScore} - ${displayAwayScore}`, 7)
                : Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_parrafo1'), 7)
            }
          </span>

          <FlagSmall
            flagUrl={away.flagUrl}
            countryName={away.name}
            iconSize='medium'
          />
        </div>

        {/* Venue */}
        <div className='card-partido-square__venue-wrapper'>
          <p className='card-partido-square__venue'>{Utils.cutPlayerString(venue || '', 35)}</p>
        </div>
      </Button>
    )
  }
}

export default CardPartidoSquare


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/CardPartidoSquare/index.jsx